import React from 'react';
import { Button } from '@cognite/cogs.js';
import styled from 'styled-components/macro';
import { getFailedInstances } from 'utils/data-validation';
import { useStoreState } from 'hooks';

export const DownloadResultsAsJsonButton = ({
  fileName = 'Result',
  runId,
  disabled,
  buttonText,
}: {
  runId: string | null | undefined;
  fileName?: string;
  disabled?: boolean;
  buttonText?: string;
}) => {
  const token = useStoreState((state) => state.auth.token);
  const tenant = useStoreState((state) => state.auth.tenant);
  const cluster = useStoreState((state) => state.auth.cluster);

  const handleDownload = async () => {
    if (!runId) return;

    const failedData = await getFailedInstances(runId, token, tenant, cluster);
    if (!failedData) return;

    const url = window.URL.createObjectURL(new Blob([failedData]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.click();
    link.remove();
  };

  return (
    <StyledDownloadButton
      icon="Download"
      iconPlacement="left"
      type="tertiary"
      disabled={!runId || disabled}
      onClick={handleDownload}
    >
      {buttonText || `${fileName}.json`}
    </StyledDownloadButton>
  );
};

const StyledDownloadButton = styled(Button)`
  margin-top: 0.5rem;
`;
